import {DOMAIN} from "@/http";
import {chose} from "./WidgetTypes";

type DoctorPhoto =
  | string
  | {
      circle?: string | null;
      square?: string | null;
    }
  | null
  | undefined;

function addNull(num: string | number): string {
  const value = String(num);
  return value.length == 1 ? "0" + value : value;
}

export function getDoctorPhoto(photo: DoctorPhoto): string | null {
  if (typeof photo === "string") {
    return photo;
  }

  return photo?.circle || photo?.square || null;
}

export function getMiniPhoto(
  img: string | null | undefined,
  defaultImg: string
): string {
  //"vrach.svg";
  //"logoWidget.svg";
  let src = `https://${DOMAIN}/api/img?size=250x250&name=`;
  src += img ? img : defaultImg;
  return src;
}
interface monthList {
  [key: string]: string;
}
export function getMonth(id: string | number): string {
  id = addNull(id);
  const monthList: monthList = {
    "01": "Январь",
    "02": "Февраль",
    "03": "Март",
    "04": "Апрель",
    "05": "Май",
    "06": "Июнь",
    "07": "Июль",
    "08": "Август",
    "09": "Сентябрь",
    "10": "Октябрь",
    "11": "Ноябрь",
    "12": "Декабрь",

    Январь: "01",
    Февраль: "02",
    Март: "03",
    Апрель: "04",
    Май: "05",
    Июнь: "06",
    Июль: "07",
    Август: "08",
    Сентябрь: "09",
    Октябрь: "10",
    Ноябрь: "11",
    Декабрь: "12"
  };
  return monthList[id];
}

export function isPhoneMasked(chose: chose): boolean {
  const phone = chose.ClientPhone;
  if (!phone) {
    return false;
  }
  if (phone.includes("-") || phone.includes("+")) {
    return phone.length == 16;
  }
  return true;
}
